import { cachedAPIWrapper } from "../apiCaching/apiWrapper";
import { isTestEnvironment } from "../apiCaching/POST-Requests/helperModules/helperFunctions";
import { apiConfig } from "../config/apiConfig";
import { GetLocateLocation, BrandDetail } from "../header/GetLocateLocation";
import { ScheduleService } from "../hms/hms-step1";
import { NearbyLocations } from "./nearbyLocations";
import { filterFranchiseData, getBrandDetailsFromBrandJson } from "./share";

export async function displayNearbyLocations(data: any, zipCode: any, brandDetail: BrandDetail): Promise<void> {
    if (!data?.length) {return handleErrorScenario(data);}
     if (data?.length > 0) {
            await handleNearbyLocationResults(data, zipCode, brandDetail);
        } else {
            handleErrorScenario(data);
        }
}

export function callNearbyLocations(units: string, franchiseLimit: number, zipCode: string,brandDetail: BrandDetail ): void {
    new NearbyLocations(units, franchiseLimit)
        .searchNearbyLocations(zipCode)
        .then((data) => displayNearbyLocations(data, zipCode,brandDetail))
        .catch(() => handleErrorScenario(zipCode));
}

export function handleNearbyLocationsFlow(inputArg: any): void {
    const conceptCode = GetLocateLocation.getInstance().getInputValue('conceptCode');

    getBrandDetailsFromBrandJson(conceptCode)
        .then((brandDetail) => {
            const findChange50mileflag = brandDetail?.enable_50mile_areameasure_findChangeMyLocation;
            const flag = brandDetail?.enable_50mile_areameasure;

            if (findChange50mileflag) {
                brandDetail?.use_miles_endPoint ? handleEnable50MilesFindMyLocationNewEndPoint(inputArg, brandDetail) : handleEnable50MilesFindMyLocation(inputArg, brandDetail);
            } else if (flag) {
                const units = brandDetail?.area_measure_values ? GetLocateLocation.getInstance().findUnits(brandDetail.area_measure_values) : 'miles';
                const franchiseLimit = brandDetail?.nearest_franchiselimit ? Number(brandDetail.nearest_franchiselimit) : 50;
                callNearbyLocations(units, franchiseLimit, inputArg, brandDetail);
            } else {
                handleErrorScenario(inputArg);
            }
        })
        .catch((err: any) => {
            console.log('Unable to read brands.json. Error:', err);
            handleErrorScenario(inputArg);
        });
}

export function handleEnable50MilesFindMyLocation(sAddressParam: any, brandDetail: BrandDetail): void {
    const units = 'miles';
    const franchiseLimit = brandDetail?.nearest_franchiselimit_findChangeMyLocation ?? 50;

    GetLocateLocation.getInstance().searchNearbyLocations(units, franchiseLimit, sAddressParam)
        .then(async (data: any) => {
            await handleNearbyLocationResults(data, sAddressParam, brandDetail);
        })
        .catch((err: any) => {
            console.log('Error searching nearby locations', err);
            handleErrorScenario(sAddressParam);
        });
}

export async function fetchNearbyLocationData(
  apiBase: string,
  zipValue: string,
  franchiseLimit: number,
  serviceIdSelector: string
): Promise<any> {
  if (!zipValue) return null;

  let api = `${apiBase}/${zipValue}/miles/${franchiseLimit}?apikey=${process.env.JS_API_KEY}`;
  const serviceIdValue = getSelectedServiceId(serviceIdSelector);

  if (serviceIdValue) {
    api += `&serviceId=${serviceIdValue}`;
  }

  try {
    const data = await cachedAPIWrapper(api);
    const response = filterFranchiseData(data);

    if (isTestEnvironment()) {
      console.log('NearByLocation:', response);
      console.log('NearByLocation length:', response?.length);
    }

    return response;
  } catch (err) {
    console.error('Error searching nearby locations', err);
    return null;
  }
}

export async function fetchNearbyLocations(units: string, franchiseLimit: number, brandDetail: BrandDetail): Promise<any> {
    let api = apiConfig.WebLocationsFranchiseGroupAPI;
    const zipCodeInput = document.getElementById("find-local-input") as HTMLInputElement;
    const zipCode = zipCodeInput.value.trim();
    const zipValue = zipCode;
    if (!zipValue) return null;
    // Convert to kilometers if required
    if (units === 'km') {
        franchiseLimit = GetLocateLocation.getInstance().milesToKilometers(franchiseLimit);
    }
    return fetchNearbyLocationData(api, zipValue, franchiseLimit, '.find-section');
}

export function getSelectedServiceId(sectionSelector: string): string | undefined {
    const findSection = document.querySelector(sectionSelector);
    if (!findSection) {return;}
    let serviceIdValue: string | undefined;
    // If find-section exists
    // Find the radio buttons inside that
    let radioButtons = findSection.querySelectorAll('input[type="radio"].radio-basic');

    if (!radioButtons || radioButtons?.length === 0) {
        radioButtons = findSection.querySelectorAll('input[type="radio"].glass-type-radio');
    }
    if (radioButtons?.length > 0) {
        for (const radioButton of radioButtons) {
            const inputElement = radioButton as HTMLInputElement;
            if (inputElement?.checked) {
                // Get the hidden input with the class 'findlocal-service-id'
                const serviceIdInput = (radioButton.parentElement?.querySelector('.findlocal-service-id')) || (radioButton.closest('.glass-type')?.querySelector('.modal-lead-service-id'))
                // Check if the input exists and has a value
                if ((serviceIdInput && serviceIdInput?.classList?.contains('findlocal-service-id') && (serviceIdInput as HTMLInputElement)?.value)|| (serviceIdInput && serviceIdInput?.classList?.contains('modal-lead-service-id') && (serviceIdInput as HTMLInputElement)?.value)) {
                    serviceIdValue = (serviceIdInput as HTMLInputElement).value;
                    return serviceIdValue;
                }
            }
        };
    }
    return undefined;

}
export async function handleEnable50MilesFindMyLocationNewEndPoint(sAddressParam: any, brandDetail: BrandDetail): Promise<void> {
    const units = brandDetail?.area_measure_values_findChangeMyLocation?.includes('miles') ?? false ? 'miles' : 'km';
    let franchiseLimit = brandDetail?.nearest_franchiselimit_findChangeMyLocation ?? 50;
    fetchNearbyLocations(units, franchiseLimit, brandDetail).then(async (response: string | any[]) => {
        if (response?.length > 0) {
            await handleNearbyLocationResults(response, sAddressParam, brandDetail);
        } else {
            handleErrorScenario(sAddressParam);
        }
    })
        .catch((error: any) => {
            console.error('Error fetching nearby locations:', error);
            handleErrorScenario(sAddressParam);
        });
}


export function handleErrorScenario(zipCode?: string): void {
    const submitButton = document.querySelector(".find-local") as HTMLButtonElement;
    const input = document.getElementById("local-search-modal") as HTMLInputElement;
    const zipCode1 = document.getElementById('find-local-input') as HTMLInputElement;
    if (zipCode1)
        input.value = zipCode1.value;
    const text1 = document.getElementById("step1-text1") as HTMLElement;
    const text2 = document.getElementById("step1-text2") as HTMLElement;
    text1.style.display = "none";
    text2.style.display = "block";
    submitButton.click();
}

// Helper method to handle different nearby location result scenarios
export async function handleNearbyLocationResults(data: any, sAddressParam: string, brandDetail?: BrandDetail): Promise<void> {
    const conceptId = GetLocateLocation.getInstance().getInputValue('conceptId');

    if (data?.length > 1) {
        GetLocateLocation.getInstance().openNearByLocationsModal(data, sAddressParam, brandDetail);
    } else if (data?.length === 1) {
        if (conceptId === '25') {
            const HMSStep1Instance = ScheduleService.getInstance();
            HMSStep1Instance.checkPOSSystemWithZip(sAddressParam);
        } else if (data[0]?.websiteUrl) {
            if (sAddressParam) {
                GetLocateLocation.getInstance().storeSessionData('sAddressParam', sAddressParam);
            }
            const hostURL = new URL(data[0].websiteUrl);
            const pathname = hostURL.pathname;
            const redirectURL = new URL(globalThis.location.href);
            const redirectHostName = redirectURL.host;
            globalThis.location.replace(`https://${redirectHostName}${pathname}`);
        } else {
            handleErrorScenario();
        }
    } else {
        handleErrorScenario();
    }
}